import Typography from "typography"
import theme from "typography-theme-shishidohinata"

const typography = new Typography(theme)

export const { scale, rhythm, options } = typography
export default typography
